// extracted by mini-css-extract-plugin
export default {"container":"select_container__OUuv8","wrapper-label":"select_wrapper-label__4dbBm","label":"select_label__7OxDR"};